import pnl3Service from '../../../services/Pnl3Service';
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'Pnl3BalanceFetcher';

/**
 * Raw I/O for the Pnl3 balance summary — no cache, no state, single responsibility.
 * BE wraps the actual payload in {status, data:{count, items, ...}} — one sid always
 * resolves to items[0] (or null when the asset has no trades yet).
 */
class Pnl3BalanceFetcher extends CoreBase {
    _name = _name;

    /**
     * @param {number|string} [sid] - 0 (default) = alle assets van de user in 1 call, BE-conventie voor "geen specifieke sid" (mirrort PK=0/unset elders in dit systeem)
     * @returns {Promise<object|object[]|null>}
     */
    fetch = async (sid = 0) => {
        try {
            const res = await pnl3Service.getSummary(sid);
            return Number(sid) === 0 ? (res?.data?.items ?? []) : (res?.data?.items?.[0] ?? null);
        } catch (error) {
            this.logError('fetch', error.message);
            return Number(sid) === 0 ? [] : null;
        }
    };
}

const pnl3BalanceFetcher = new Pnl3BalanceFetcher();
export default pnl3BalanceFetcher;
